import { MobXModel } from "src/repository/MobXModel";
import { INewsCategoryClient } from "./INewsCategoryClient";

export const newsCategoryClientModel = new MobXModel<INewsCategoryClient>();
